export default "__VITE_ASSET__Dk$Rqcvg__"